import { render, staticRenderFns } from "./GroupSession.vue?vue&type=template&id=0b841c6e&scoped=true&"
import script from "./GroupSession.vue?vue&type=script&lang=ts&"
export * from "./GroupSession.vue?vue&type=script&lang=ts&"
import style0 from "./GroupSession.vue?vue&type=style&index=0&id=0b841c6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b841c6e",
  null
  
)

export default component.exports